var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "864B84B1-FB66-4634-BBF7-4076FF1DE895@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-88.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/open",
    transform: "translate(88.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2C3C9",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,16.25 C16.0286458,16.25 16.3841146,16.0130208 16.5664062,15.5390625 L16.5664062,15.5390625 L18.34375,11.4375 C18.3984375,11.2916667 18.4257812,11.1458333 18.4257812,11 L18.4257812,11 L18.4257812,9.87890625 L18.3984375,9.87890625 L18.4257812,9.82421875 C18.4257812,9.51432292 18.3072917,9.24544271 18.0703125,9.01757812 C17.8333333,8.78971354 17.5598958,8.67578125 17.25,8.67578125 L17.25,8.67578125 L13.5585938,8.67578125 L14.1328125,5.99609375 L14.1328125,5.8046875 C14.1328125,5.56770833 14.0507812,5.3671875 13.8867188,5.203125 L13.8867188,5.203125 L13.2578125,4.57421875 L9.4296875,8.4296875 C9.19270833,8.66666667 9.07421875,8.94010417 9.07421875,9.25 L9.07421875,9.25 L9.07421875,15.0742188 C9.07421875,15.3841146 9.19270833,15.6575521 9.4296875,15.8945312 C9.66666667,16.1315104 9.94010417,16.25 10.25,16.25 L10.25,16.25 L15.5,16.25 Z M7.92578125,16.25 L7.92578125,9.25 L5.57421875,9.25 L5.57421875,16.25 L7.92578125,16.25 Z",
    id: "\\uE8DC",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.469e6fb73402a080635fa1dadcf5d698.svg";
export { ForwardRef as ReactComponent };